import React, { ChangeEvent, useEffect, useState } from "react";
import { Collapsible, Box } from "@bca/ui-library";

export interface FilterProps {
  id: string;
  label: string;
  resultsCount: number;
  categoryId: string;
  isSelected: boolean;
  section?: string;
}
export interface CollapsibleSectionProps {
  title: string;
  isDisabled?: boolean;
  children?: any;
  onRemoveFilter?: (filterId: string, categoryId: string) => void;
  categoryKey: string;
  setCurrentFacet: (string) => void;
  currentFacet: string;
}

const CollapsibleFacet = ({
  title,
  isDisabled = false,
  children,
  categoryKey,
  setCurrentFacet,
  currentFacet,
}: CollapsibleSectionProps) => {
  const [isClosed, setIsClosed] = useState(true);

  const handleOnChange = (event: ChangeEvent<unknown>, isClosed: boolean) => {
    setCurrentFacet(categoryKey);
    setIsClosed(isClosed);
  };

  useEffect(() => {
    if (isDisabled) {
      setIsClosed(isDisabled);
    }
  }, [isDisabled]);

  const isCollapsed = categoryKey !== currentFacet || isClosed;
  return (
    <Box mb={!isClosed && categoryKey === currentFacet && 5}>
      {/* @ts-expect-error */}
      <Collapsible
        title={title}
        disabled={isDisabled}
        closed={isCollapsed}
        onChange={(event: ChangeEvent<unknown>, isClosed: boolean) =>
          handleOnChange(event, isClosed)
        }
      >
        {!isCollapsed && children}
      </Collapsible>
    </Box>
  );
};

export default CollapsibleFacet;
